<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-12">
        <h4 class="card-title text-left">상태</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select class="select-primary" @change="getInqueries(1)" size="large" placeholder="상태" v-model="state">
              <el-option v-for="option in states" class="select-primary" :value="option.id" :label="option.name" :key="option.name"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <el-table :data="data" @row-click="rowClicked">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BasePagination } from "@/components/index";
import { URLUtils } from "@/util/URLUtils";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
  },
  async created() {
    await this.getInqueries();
  },
  data() {
    return {
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "userId",
          label: "유저아이디",
          minWidth: 100,
        },
        {
          prop: "email",
          label: "이메일",
          minWidth: 100,
        },
        {
          prop: "stateName",
          label: "상태",
          minWidth: 50,
        },
        {
          prop: "regTime",
          label: "작성일",
          minWidth: 150,
        },
      ],
      data: [],
      currentPage: 1,
      totalPages: null,
      state: 1,
      states: [
        { id: 1, name: "접수" },
        { id: 0, name: "처리완료" },
        { id: -1, name: "삭제" },
      ],
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getInqueries(this.currentPage);
      },
    },
  },
  methods: {
    async getInqueries(page) {
      const params = { state: this.state };
      params.currentPage = page ? page : 1;
      return this.$axios.get("/inquery", { params }).then((res) => {
        this.data = res.data.data.data;
        this.data = this.data.map((item) => {
          if (item.state === 1) {
            item.stateName = "접수";
          } else if (item.state === 0) {
            item.stateName = "처리완료";
          } else if (item.state === -1) {
            item.stateName = "삭제";
          }
          item.regTime = formatDateTime(item.regTime);
          return item;
        });
        this.totalPages = Number(res.data.data.page);
      });
    },
    rowClicked(row) {
      this.$router.push(`/inqueries/inqueryDetail?${URLUtils.objectToQueryString({ id: row.id })}`);
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
